import { PartnerInfoTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";

export const PartnerInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case PartnerInfoTypes.unset:
      return Object.assign({}, InitialState.createSyncObject());
    case PartnerInfoTypes.updateInfo:
      let newState = Object.assign({}, state, {
        data: Object.assign({}, state.data, action.partnerInfo.data),
        lastSync: action.partnerInfo.lastSync
      });
    case PartnerInfoTypes.set:
      return Object.assign({}, state, action.partnerInfo);
    default:
      return Object.assign({}, state, action.partnerInfo);
  }
};
